import React, {useState} from 'react';
import {IonIcon, useIonAlert} from '@ionic/react';
import {briefcaseOutline, calendarOutline, mailOutline, shareSocialOutline} from 'ionicons/icons';
import moment from "moment-timezone";
import useStore from "../zustand/useStore";
import {
    actionToApplyForAssignmentPortalPost,
    actionToDeleteAssignmentPortalPost,
} from "../apiHelpers/CommonAction";
import RaiseRFPModal from "./RaiseRFPModal";
import {Capacitor} from "@capacitor/core";
import {Share} from "@capacitor/share";

export default function AssignmentDataCard({ assignment,handleDetailItemClick ,selectedId}) {
    const {userAuthDetail} = useStore();
    const {userInfo} = userAuthDetail;
    const [presentAlert] = useIonAlert();
    const [showRaiseRFP, setShowRaiseRFP] = useState(false);
    const [dataForEditing, setDataForEditing] = useState({});

    const openRfpMailClient = async (rfpData) => {
        let interestedMembers = [];
        if (rfpData?.applied_member_id_array) {
            interestedMembers = JSON.parse(rfpData.applied_member_id_array);
        }

        if (!interestedMembers?.includes(userInfo?.id)) {
            interestedMembers.push(userInfo?.id);

            let template = await actionToApplyForAssignmentPortalPost(
                rfpData?.id,
                JSON.stringify(interestedMembers)
            );

            const subject = encodeURIComponent("RFP Assignment - Interested Candidate");
            let body = encodeURIComponent(
                "Hello,\n\nI am interested in this RFP assignment.\n\nThanks."
            );

            if (template) {
                let filledTemplate = template
                    .replace(/{ASSIGNMENT_TITLE}/g, rfpData?.title || "")
                    .replace(/{NAME}/g, userInfo?.name || "")
                    .replace(/{MOBILE}/g, userInfo?.phone_number || "")
                    .replace(/{EMAIL}/g, userInfo?.email || "");

                body = encodeURIComponent(filledTemplate);
            }

            window.location.href = `mailto:${rfpData?.apply_email}?subject=${subject}&body=${body}`;
        }
    };

    const callFunctionToDelete = (e,id)=>{
        e.preventDefault();
        presentAlert({
            header: 'Are you sure?',
            cssClass: 'custom_site_alert_toast',
            message: 'You want to delete this RFP.',
            buttons: [
                {text: 'Cancel', role: 'cancel'},
                {text: 'Delete', role: 'confirm', handler: async () =>{
                        await actionToDeleteAssignmentPortalPost(id)
                    }},
            ],
        });
    }
    const applyForAssignment = (data)=>{
        presentAlert({
            header: 'Are you sure?',
            cssClass: 'custom_site_alert_toast',
            message: 'You want to apply for this assignment.',
            buttons: [
                {text: 'Cancel', role: 'cancel'},
                {text: 'Apply', role: 'confirm', handler: () =>openRfpMailClient(data)},
            ],
        });
    }

    const callFunctionToSetEditData = (e,data)=>{
        e.preventDefault();
        setDataForEditing(data);
        setShowRaiseRFP(true);
    }

    const handleShareUrl = async (assignmentData) => {
        try {
            const url = `https://caworld.org/api-ca-world/common/shareAppContentData/assignments/${assignmentData?.id}`;
            const title = 'CA World Assignment';
            const text = 'Check out this Assignment detail!';

            // Prefer native Share plugin when running in a Capacitor app.
            // Don't gate on canShare() for text/URL — it's mainly helpful for FILE sharing.
            const isNative = Capacitor.getPlatform() !== 'web';
            const hasPlugin = Capacitor.isPluginAvailable?.('Share');

            if (isNative && hasPlugin) {
                await Share.share({
                    title,
                    text,
                    url,                  // supports http/https and file://
                    dialogTitle: 'Share this assignment', // Android only
                });
                return;
            }

            // Web Share API (must be triggered from a direct user gesture)
            if (navigator?.share) {
                await navigator.share({ title, text, url });
                return;
            }

            // Fallbacks
            try {
                await navigator?.clipboard?.writeText?.(url);
                presentAlert({
                    header: 'Error Sharing!',
                    message: 'Link copied to clipboard!',
                    buttons: [{
                        text: 'Ok',
                    }],
                });
            } catch {
                window.prompt('Sharing is not supported. Copy this link:', url);
            }
        } catch (err) {
            console.error('Sharing failed:', err);
            presentAlert({
                header: 'Error Sharing!',
                message: 'Failed to share!',
                buttons: [{
                    text: 'Ok',
                }],
            });
        }
    };


    return (
        <div className={`rfp-card ${selectedId === assignment?.id ? 'active' : ''}`}>
            <div className="rfp-card-left">
                <div className="rfp-card-detail-price_menu">
                    <h4>
                        {assignment.title}
                    </h4>
                    <div>
                        <div className="rfp-price">₹{assignment.price}</div>
                        <div className="rfp-min">Min. price</div>
                    </div>
                </div>
                <div className="rfp-details" onClick={()=>handleDetailItemClick(assignment)}>
                    <span className="rfp-location"><IonIcon icon={briefcaseOutline}/> {assignment.location}</span>
                    <span className="rfp-days"><IonIcon icon={mailOutline}/> {assignment.email}</span>
                    <span className="rfp-days"><IonIcon icon={calendarOutline}/>
                        {
                            (() => {
                                const daysLeft = moment(assignment.expiry_date).startOf('day').diff(moment().startOf('day'), 'days');
                                return daysLeft < 0
                                    ? 'Expired'
                                    : `${daysLeft} Day${daysLeft !== 1 ? 's' : ''} Left`;
                            })()
                        }
                    </span>
                    <div className={`approved_tag_section_tag ${assignment?.is_approved ? 'approved' : 'not_approved'}`}>
                        {assignment?.is_approved ? 'Approved' : 'Pending'}
                    </div>
                </div>
                <div className={"in_card_action_buttons_container"}>
                    {(selectedId !== assignment?.id) ?
                    <div onClick={()=>handleDetailItemClick(assignment)} className="in_card_action_button_edit_del open">
                        Open
                    </div>:''
                    }
                    {(assignment?.created_by === userInfo?.id) ?
                        <>
                            <div onClick={(e)=>callFunctionToSetEditData(e,assignment)} className="in_card_action_button_edit_del edit">
                                Edit
                            </div>
                            <div onClick={(e)=>callFunctionToDelete(e,assignment?.id)} className="in_card_action_button_edit_del">
                                Delete
                            </div>
                        </>
                        :
                        <>
                            {(assignment?.applied_member_id_array && JSON.parse(assignment?.applied_member_id_array).includes(userInfo?.id)) ?
                                <div className="in_card_action_button_edit_del">
                                    Applied
                                </div>
                                :
                                <div onClick={() => applyForAssignment(assignment)} className="in_card_action_button_edit_del">
                                    Apply
                                </div>
                            }
                        </>
                    }
                    <div className="in_card_action_button_edit_del share">
                        <IonIcon icon={shareSocialOutline} onClick={()=>handleShareUrl(assignment)}></IonIcon>
                    </div>
                </div>
            </div>
            {(showRaiseRFP) ?
            <RaiseRFPModal isOpen={showRaiseRFP} fromAdminList={false} dataForEditing={dataForEditing} onDismiss={() => setShowRaiseRFP(false)}/>
                :''
            }
        </div>
    );
}
